module.exports = __webpack_public_path__ + "static/media/pencil_circle.cc9778a1.svg";